import classNames from 'clsx';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import CheckGreen from '../../../../../../assets/icons/check-green.svg';
import CloseIcon from '../../../../../../assets/icons/close-red.svg';
import { CardType } from '../../../../../../types/cardType';
import { filteredUnverifiedOptions } from '../../../../../../utils/cashier';

import {
  container,
  documentsIcon,
  unverifiedContent,
  unverifiedWrapper
} from './DocumentRequirements.scss';
import DocumentsGroup from './DocumentsGroup/DocumentsGroup';
import { defaultMessages, translationMap } from './utils/translationUtils';

interface Props {
  className?: string;
  type: number;
  i18nSystemName: string;
}

const DocumentRequirements: React.FC<Props> = ({ className, type, i18nSystemName }) => {
  const {
    data: { unverifiedOptions = [] }
  } = useWizardContext();
  // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
  const { acceptedDocuments, requiredDocuments } = translationMap[type] || defaultMessages;
  const hasMaskIcon = [
    CardType.Visa,
    CardType.MasterCard,
    CardType.Solo,
    CardType.MuchBetter
  ].includes(type);

  const filteredOptions = filteredUnverifiedOptions(unverifiedOptions, i18nSystemName);

  return (
    <div className={classNames(container, className)}>
      <div>
        <DocumentsGroup
          title={acceptedDocuments.title}
          options={acceptedDocuments.options}
          i18nSystemName={i18nSystemName}
          icon={<CheckGreen className={documentsIcon} />}
          cardHidingIcon={hasMaskIcon}
          iconIndex={type === CardType.MuchBetter ? 1 : 0}
        />
        {filteredOptions.length > 1 && (
          <ul className={unverifiedWrapper}>
            {filteredOptions.map((opt) => (
              <li className={unverifiedContent} key={opt.ref}>
                {opt.paySystemName} {opt.ref}
              </li>
            ))}
          </ul>
        )}
      </div>
      <DocumentsGroup
        title={requiredDocuments.title}
        options={requiredDocuments.options}
        i18nSystemName={i18nSystemName}
        icon={<CloseIcon className={documentsIcon} />}
      />
    </div>
  );
};

DocumentRequirements.displayName = 'DocumentRequirements';

export default DocumentRequirements;
